import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { HandspraySiteDetail } from 'src/app/models/handspray.model';

@Injectable({
  providedIn: 'root'
})
export class HandspraySiteResolverService {

  constructor(private http: HttpClient) { }

  resolve(route: ActivatedRoute): Observable<HandspraySiteDetail> {
    const params = new HttpParams().set('site', route.params['site']);
    return this.http.get<HandspraySiteDetail>(environment.baseUrl + 'handspray/site/get', { params: params });
  }
}
